import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner } from 'react-bootstrap';
import { FaEdit, FaTrash, FaLock, FaUnlock } from 'react-icons/fa';
import ErrorModal from './ErrorModal';
import HierarchyViewer, { getHierarchyLevel } from './HierarchyViewer';

// Feature-Flag: Hierarchie-Viewer ein-/ausschaltbar, ohne Code zu entfernen.
const SHOW_HIERARCHY_VIEWER = true;

// Vorgabe-Werte fuer Eintraege pro Seite (+ manuelle Eingabe).
const PAGE_SIZE_PRESETS = [10, 25, 50, 100, 250, 500];
const PAGE_SIZE_MIN = 1;
const PAGE_SIZE_MAX = 1000;
const PAGE_SIZE_CUSTOM = "custom";

const BoardUsers = () => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  // Aktuell in der Tabelle ausgewaehlte Zeile (steuert den Hierarchie-Viewer).
  const [selectedRow, setSelectedRow] = useState(null);
  const [roles, setRoles] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Select-Wert: Preset-Zahl als String oder "custom".
  const [pageSizeSelect, setPageSizeSelect] = useState("10");
  // Freitext fuer manuelle Eingabe (wird erst bei gueltigem Wert uebernommen).
  const [customPageSizeInput, setCustomPageSizeInput] = useState("");


  const [formData, setFormData] = useState({
    username: '',
    userRoles: [
      {
        role: { id: 3 }
      }
    ],
    email: '',
    password: '',
    confirmPassword: '',
    roleId: ''
    
    
    
  });


  console.log(formData);

  

  const validateForm = () => {
    const newErrors = {};
    console.log("Validation is performed");
    // Validate company_name
    if (!formData.username.trim()) {
      newErrors.username = 'Benutzername ist ein Pflichtfeld';
    } 
    
    const roleId = formData.userRoles?.[0]?.role?.id;
    if (roleId === undefined || roleId === null || roleId === "" || isNaN(roleId) ) {
      
      newErrors.roleId = 'Ungültige Rollen-ID: Rollen-ID muss definiert sein';
     
    }
   
    if (parseInt(roleId, 10) <= 0) {
      
      console.log("Roleid Validation"+roleId);
      newErrors.roleId = 'Ungültige Rollen-ID: Rollen-ID muss eine Zahl größer als 0 sein.';
     
    }
    
    // Validate company_email (example: must be a valid email)
    if (!formData.email.trim()) {
      newErrors.email = 'Benutzer-E-Mail ist ein Pflichtfeld';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Benutzer-E-Mail muss eine gültige E-Mail-Adresse sein';
    }
    
    // Validate password
  if (!formData.password.trim()) {
    newErrors.password = 'Passwort ist ein Pflichtfeld';
  } else if (formData.password.length < 8) {
    newErrors.password = 'Das Passwort muss mindestens 8 Zeichen lang sein';
  } else if (!/[A-Z]/.test(formData.password)) {
    newErrors.password = 'Das Passwort muss mindestens einen Großbuchstaben enthalten';
  } else if (!/[a-z]/.test(formData.password)) {
    newErrors.password = 'Das Passwort muss mindestens einen Kleinbuchstaben enthalten';
  } else if (!/[0-9]/.test(formData.password)) {
    newErrors.password = 'Das Passwort muss mindestens eine Zahl enthalten';
  } else if (!/[!@#$%^&*]/.test(formData.password)) {
    newErrors.password = 'Das Passwort muss mindestens ein Sonderzeichen enthalten';
  }


  // Validate confirmPassword
  /*
  if (!formData.confirmPassword.trim()) {
    newErrors.confirmPassword = "Confirm Password is required";
  }else if (formData.confirmPassword.length < 8) {
    newErrors.confirmPassword = 'Confirm Password must be at least 8 characters long';
  } else if (!/[A-Z]/.test(formData.password)) {
    newErrors.confirmPassword = 'Confirm Password must contain at least one uppercase letter';
  } else if (!/[a-z]/.test(formData.password)) {
    newErrors.confirmPassword = 'Confirm Password must contain at least one lowercase letter';
  } else if (!/[0-9]/.test(formData.password)) {
    newErrors.confirmPassword = 'Confirm Password must contain at least one number';
  } else if (!/[!@#$%^&*]/.test(formData.password)) {
    newErrors.confirmPassword = 'Confirm Password must contain at least one special character';
  } else if (formData.password !== formData.confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match";
  }
*/

    console.log("Keine Errors"+Object.keys(newErrors).length === 0);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };
  
  
  useEffect(() => {
    validateForm();
  }, [formData]); // This will run every time formData is updated

  useEffect(() => {
    
    console.log("UseEffcet is performed");
    UserService.getUsersBoard().then(
      (response) => {
        setUsers(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Fehler: Keine Antwort vom Server erhalten.');
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Fehler: ${error.response.data.message}`);
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } 
        setUsers(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});

UserService.getRolesBoard().then(
  (response) => {
    
    setRoles(response.data);
    
  },
  (error) => {
    const _content =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      error.toString();
      if (error.response) {
        // Server responded with a status other than 200 range
        setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
        setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      } else if (error.request) {
        // Request was made, but no response was received
        setApiErrors('Fehler: Keine Antwort vom Server erhalten.');
        setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      } else {
        // Other types of errors
        setApiErrors(`Fehler: ${error.response.data.message}`);
        setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      } 
      setRoles(_content);

    if (error.response && error.response.status === 401) {
      EventBus.dispatch("logout");
    }
  }
);


  }, [deleteState]);
  
 
/*
   id
  username
  email
  password
  createdAt
  updatedAt
 */

// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(users)
    ? users.filter((vo) => {
        const roleName = vo?.userRoles?.[0]?.role?.name || "";
        return (
          (vo.name && vo.name.toLowerCase().includes(filterTerm.toLowerCase())) ||
          (vo.username && vo.username.toLowerCase().includes(filterTerm.toLowerCase())) ||
          (vo.email && vo.email.toLowerCase().includes(filterTerm.toLowerCase())) ||
          (roleName && roleName.toLowerCase().includes(filterTerm.toLowerCase())) ||
          (vo.parent_vo_label && vo.parent_vo_label.toLowerCase().includes(filterTerm.toLowerCase())) ||
          (vo.createdAt && vo.createdAt.includes(filterTerm)) ||
          (vo.updatedAt && vo.updatedAt.includes(filterTerm))
        );
      })
    : [];

  // Handle pagination
  const handlePageChange = (pageNumber) => {
    if (!pageNumber || pageNumber < 1) return;
    setCurrentPage(pageNumber);
  };

  // Uebernimmt eine gueltige Seitengröße und springt auf Seite 1.
  const applyItemsPerPage = (rawValue) => {
    const n = parseInt(rawValue, 10);
    if (!Number.isFinite(n) || n < PAGE_SIZE_MIN || n > PAGE_SIZE_MAX) {
      return false;
    }
    setItemsPerPage(n);
    setCurrentPage(1);
    return true;
  };

  // Select: Preset oder Umschalten auf manuelle Eingabe.
  const handlePageSizeSelectChange = (e) => {
    const value = e.target.value;
    setPageSizeSelect(value);
    if (value === PAGE_SIZE_CUSTOM) {
      setCustomPageSizeInput(String(itemsPerPage));
      return;
    }
    applyItemsPerPage(value);
  };

  // Manuelle Eingabe: bei Enter/Blur uebernehmen, sonst Eingabe zwischenspeichern.
  const handleCustomPageSizeChange = (e) => {
    setCustomPageSizeInput(e.target.value);
  };

  const commitCustomPageSize = () => {
    if (applyItemsPerPage(customPageSizeInput)) {
      setCustomPageSizeInput(String(parseInt(customPageSizeInput, 10)));
    } else {
      setCustomPageSizeInput(String(itemsPerPage));
    }
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Zuerst sortieren, dann paginieren – sonst zeigt die Tabelle immer alle Zeilen.
  const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
    let aValue, bValue;
  
    // Handle nested properties for sorting
    if (sortConfig.key === 'userRoles[0].role.name') {
      aValue = a.userRoles?.[0]?.role?.name || '';
      bValue = b.userRoles?.[0]?.role?.name || '';
    }
    else if (sortConfig.key === 'stufe') {
      aValue = getHierarchyLevel(a.userRoles?.[0]?.role?.name)?.stufe || 0;
      bValue = getHierarchyLevel(b.userRoles?.[0]?.role?.name)?.stufe || 0;
    }
    else if (sortConfig.key === 'name') {
      aValue = (a.name || '').toString().toLowerCase();
      bValue = (b.name || '').toString().toLowerCase();
    }
    else if (sortConfig.key === 'parent_vo_label') {
      aValue = (a.parent_vo_label || '').toString().toLowerCase();
      bValue = (b.parent_vo_label || '').toString().toLowerCase();
    }
    else {
      // For non-nested keys
      aValue = a[sortConfig.key];
      bValue = b[sortConfig.key];
    }
  
    // Perform the comparison based on direction
    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const totalPages = Math.max(1, Math.ceil(filteredMainVOs.length / itemsPerPage));
  const safePage = Math.min(Math.max(currentPage, 1), totalPages);
  const indexOfLastItem = safePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMainVOs = sortedMainVOs.slice(indexOfFirstItem, indexOfLastItem);

  const handleEditClick = (main_vo) => {
    setApiErrors(null);
    setApiErrorCode(null);
    const roleId = main_vo.userRoles?.[0]?.role?.id ?? "";
    console.info('Selected Main VO ID:', roleId);
    console.info('Selected Main VO ID1:', formData);
    setSelectedRoleId(roleId === "" ? null : roleId);
    
    setSelectedUser(main_vo);
    setFormData({
      ...main_vo,
      username: main_vo.username || "",
      email: main_vo.email || "",
      password: main_vo.password || "",
      userRoles: [
        {
          ...(main_vo.userRoles?.[0] || {}),
          role: {
            ...(main_vo.userRoles?.[0]?.role || {}),
            id: roleId,
          },
        },
      ],
    });
    console.info('Selected Main VO ID2:', formData);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      username: "",
      email: "",
      password: "",
      userRoles: [
        {
          role: {
            id: 0, // Default value for role.id
          }
        }
      ] });
    setShowCreateModal(true);
  };


  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteUsersBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Fehler beim Löschen des Benutzers:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  // Sperrt oder entsperrt einen Benutzer. Das eigene Konto kann nicht gesperrt
  // werden (zusaetzlich serverseitig abgesichert).
  const handleToggleLock = async (user, e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    const target = !user.locked;
    try {
      setLoadingText(target ? 'Benutzer wird gesperrt, bitte warten...' : 'Benutzer wird entsperrt, bitte warten...');
      setLoading(true);
      await UserService.setUserLock(user.id, target);
      setDeleteState(prev => !prev);
    } catch (error) {
      const msg = (error.response && error.response.data && error.response.data.message) || error.message;
      setApiErrors(`Fehler: ${error.name}-${error.code} - ${msg}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Fehler beim Sperren/Entsperren des Benutzers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    
    console.log(formData);
    console.log(selectedUser);
    console.log(selectedUser?.userRoles?.[0]?.role?.id);
    console.log(selectedUser.id);
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      console.log(selectedUser.id);
      // formData.rec_date = new Date();
      await UserService.updateUsersBoard(selectedUser.id,formData.userRoles?.[0]?.role?.id,formData);
      console.log(selectedUser.id);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Fehler beim Aktualisieren des Benutzers:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };


  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createUsersBoard(formData.userRoles?.[0]?.role?.id,formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Fehler beim Erstellen des Benutzers:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  

  
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    console.log("Select Name:"+e.target.name);
    console.log("Select Value before :"+value);
   
    // Handle nested userRoles role.id update
    if (name === "roleId") {
      
      setFormData((prevState) => ({
        ...prevState,
        userRoles: [
          {
            ...(prevState.userRoles?.[0] || {}),
            role: {
              ...(prevState.userRoles?.[0]?.role || {}),
              id: value, // Update the role id
            },
          },
        ],
      }));
      console.log("Select Value after:"+value);
    } else {
      // Handle all other input updates
      setFormData({
        ...formData,
        [name]: value,
      });
      
      
    }
    if (!validateForm()) return; 
    console.log("Updated formData:", formData);
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Benutzerübersicht</h1>
                {/* Display error if it exists */}
        
      {/* Display error if it exists */}
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />

      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Erstellen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Benutzername, ID und Datum"
          value={filterTerm}
          onChange={(e) => {
            setFilterTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </Form.Group>
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
              Name {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('username')} style={{ cursor: 'pointer' }}>
              Benutzername {sortConfig.key === 'username' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('email')} style={{ cursor: 'pointer' }}>
              E-Mail {sortConfig.key === 'email' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('userRoles[0].role.name')} style={{ cursor: 'pointer' }}>
              Rolle {sortConfig.key === 'userRoles[0].role.name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('stufe')} style={{ cursor: 'pointer' }}>
              Stufe {sortConfig.key === 'stufe' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('parent_vo_label')} style={{ cursor: 'pointer' }}>
              Übergeordneter VO {sortConfig.key === 'parent_vo_label' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('createdAt')} style={{ cursor: 'pointer' }}>
              Erstelldatum {sortConfig.key === 'createdAt' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('updatedAt')} style={{ cursor: 'pointer' }}>
              Änderungsdatum {sortConfig.key === 'updatedAt' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('locked')} style={{ cursor: 'pointer' }}>
              Status {sortConfig.key === 'locked' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {currentMainVOs.map((vo) => (
            <tr
              key={vo.id}
              onClick={() => setSelectedRow(vo)}
              className={`hv-clickable-row${selectedRow && selectedRow.id === vo.id ? ' hv-selected-row' : ''}`}
            >
              <td>
                {vo.name
                  ? vo.name
                  : <span className="text-muted">–</span>}
              </td>
              <td>{vo.id}</td>
              <td>{vo.username}</td>
              <td>{vo.email}</td>
              <td>
                {vo.userRoles?.[0]?.role?.name
                  ? vo.userRoles[0].role.name
                  : <span className="text-muted">–</span>}
              </td>
              <td>
                {(() => {
                  const lvl = getHierarchyLevel(vo.userRoles?.[0]?.role?.name);
                  return lvl ? (
                    <span
                      className="hv-stufe-badge"
                      style={{ backgroundColor: lvl.color }}
                      title={lvl.label}
                    >
                      {lvl.stufe}. Stufe
                    </span>
                  ) : (
                    <span className="text-muted">–</span>
                  );
                })()}
              </td>
              <td>
                {vo.parent_vo_label
                  ? vo.parent_vo_label
                  : <span className="text-muted">–</span>}
              </td>
              <td style={{ whiteSpace: 'nowrap' }}>{vo.createdAt}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{vo.updatedAt}</td>
              <td>
                {vo.locked
                  ? <span className="badge bg-danger">Gesperrt</span>
                  : <span className="badge bg-success">Aktiv</span>}
              </td>
              <td>
                <ButtonGroup>
                  <Button variant="warning" onClick={() => handleEditClick(vo)} title="Bearbeiten" aria-label="Bearbeiten">
                    <FaEdit />
                  </Button>
                  <Button
                    variant={vo.locked ? "success" : "secondary"}
                    onClick={(e) => handleToggleLock(vo, e)}
                    disabled={!!currentUser && currentUser.username === vo.username}
                    title={
                      !!currentUser && currentUser.username === vo.username
                        ? "Das eigene Konto kann nicht gesperrt werden"
                        : (vo.locked ? "Entsperren" : "Sperren")
                    }
                    aria-label={vo.locked ? "Entsperren" : "Sperren"}
                  >
                    {vo.locked ? <FaUnlock /> : <FaLock />}
                  </Button>
                  <Button variant="danger" onClick={(e) => handleDeleteClick(vo.id,e)} title="Löschen" aria-label="Löschen">
                    <FaTrash />
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-2 mb-3">
        <Pagination className="mb-0">
          <Pagination.First onClick={() => handlePageChange(1)} disabled={safePage === 1} />
          <Pagination.Prev onClick={() => handlePageChange(safePage - 1)} disabled={safePage === 1} />

          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === safePage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}

          <Pagination.Next onClick={() => handlePageChange(safePage + 1)} disabled={safePage === totalPages} />
          <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={safePage === totalPages} />
        </Pagination>

        <Form.Group
          controlId="usersPageSize"
          className="d-flex flex-wrap align-items-center gap-2 mb-0"
          style={{ minHeight: 44 }}
        >
          <Form.Label className="mb-0 text-nowrap">Einträge pro Seite</Form.Label>
          <Form.Select
            value={pageSizeSelect}
            onChange={handlePageSizeSelectChange}
            aria-label="Einträge pro Seite auswählen"
            style={{ width: "auto", minWidth: 120, minHeight: 44 }}
          >
            {PAGE_SIZE_PRESETS.map((size) => (
              <option key={size} value={String(size)}>{size}</option>
            ))}
            <option value={PAGE_SIZE_CUSTOM}>Manuell</option>
          </Form.Select>
          {pageSizeSelect === PAGE_SIZE_CUSTOM && (
            <Form.Control
              type="number"
              min={PAGE_SIZE_MIN}
              max={PAGE_SIZE_MAX}
              inputMode="numeric"
              value={customPageSizeInput}
              onChange={handleCustomPageSizeChange}
              onBlur={commitCustomPageSize}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  commitCustomPageSize();
                }
              }}
              aria-label="Einträge pro Seite manuell eingeben"
              title={`Zahl zwischen ${PAGE_SIZE_MIN} und ${PAGE_SIZE_MAX}`}
              style={{ width: 100, minHeight: 44 }}
            />
          )}
          <span className="text-muted small text-nowrap">
            {(filteredMainVOs.length === 0)
              ? "0 Einträge"
              : `${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, filteredMainVOs.length)} von ${filteredMainVOs.length}`}
          </span>
        </Form.Group>
      </div>
      {SHOW_HIERARCHY_VIEWER && (
        <HierarchyViewer
          activeRole={selectedRow?.userRoles?.[0]?.role?.name}
        />
      )}
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Benutzerrolle erstellen</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
          <Form.Group controlId="formAreaGroupName">
              <Form.Label>Benutzername</Form.Label>
              <Form.Control
                type="text"
                placeholder="Benutzernamen eingeben"
                name="username"
                value={formData.username}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback type="invalid">
                {errors.username}
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group controlId="formAreaGroupName">
            <Form.Label>E-Mail</Form.Label>
              <Form.Control
                type="text"
                placeholder="E-Mail eingeben"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formAreaGroupName">
            <Form.Label>Passwort</Form.Label>
              <Form.Control
                type="password"
                placeholder="Passwort eingeben"
                name="password"
                value={formData.password}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>

           

            <Form.Group controlId="formCountry">
        <Form.Label>Benutzerrolle auswählen</Form.Label>
        <Form.Group>
  
  <Form.Control
    as="select"
    name="roleId"  // The field name matches what's used in validation
    value={formData.userRoles?.[0]?.role?.id ?? ""}  // Bound to the roleId in state
    onChange={handleChange}  // Update form data on selection change
    isInvalid={!!errors?.roleId}  // Check if there's an error for roleId
  >
    <option value="">Benutzerrolle auswählen</option>
    {Array.isArray(roles) && roles.map(role => (
      <option key={role.id} value={role.id}>
        {role.name}
      </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">
    {errors?.roleId}  
  </Form.Control.Feedback>
</Form.Group>

      </Form.Group>

      <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Wird gespeichert...' : 'Benutzer speichern'}
             
            </Button>

            
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Benutzerrolle bearbeiten</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
          <Form.Group controlId="formAreaGroupName">
              <Form.Label>Benutzername</Form.Label>
              <Form.Control
                type="text"
                placeholder="Benutzernamen eingeben"
                name="username"
                value={formData.username}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.username}
              />
              <Form.Control.Feedback type="invalid">
                {errors.username}
              </Form.Control.Feedback>
            </Form.Group>
            
            <Form.Group controlId="formAreaGroupName">
            <Form.Label>E-Mail</Form.Label>
              <Form.Control
                type="text"
                placeholder="E-Mail eingeben"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formAreaGroupName">
            <Form.Label>Passwort</Form.Label>
              <Form.Control
                type="password"
                placeholder="Passwort eingeben"
                name="password"
                value={formData.password}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.password}
              </Form.Control.Feedback>
            </Form.Group>

           

            <Form.Group controlId="formCountry">
        <Form.Label>Benutzerrolle auswählen</Form.Label>
        <Form.Group>
  
  <Form.Control
    as="select"
    name="roleId"  // The field name matches what's used in validation
    value={formData.userRoles?.[0]?.role?.id ?? ""}  // Bound to the roleId in state
    onChange={handleChange}  // Update form data on selection change
    isInvalid={!!errors?.roleId}  // Check if there's an error for roleId
  >
    <option value="">Benutzerrolle auswählen</option>
    {Array.isArray(roles) && roles.map(role => (
      <option key={role.id} value={role.id}>
        {role.name}
      </option>
    ))}
  </Form.Control>
  <Form.Control.Feedback type="invalid">
    {errors?.roleId}  
  </Form.Control.Feedback>
</Form.Group>

      </Form.Group>

      <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Wird aktualisiert...' : 'Benutzer aktualisieren'}
            
            </Button>
            
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardUsers;